import { set } from 'lodash';
export default function transformFilterModelFromV1ToV0(fcv1) {
    const res = {};
    for (const fc of fcv1) {
        set(res, fc.field + '.' + fc.predicate, fc.value);
    }
    return res;
}
